//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DIC from '@/index/dictionary'
import InventorySub from './components/inventorySub'
export default {
  components:{
    InventorySub
  },
  data() {
    return {
      shopName:'',
      initShopArea:'全部',
      shopAreaList:[
        {value: '全部',label: '全部'}, 
        {value: '锦江',label: '锦江'}, 
        {value: '青羊',label: '青羊'}, 
        {value: '金牛',label: '金牛'}, 
        {value: '武侯',label: '武侯'}, 
        {value: '成华',label: '成华'}, 
        {value: '龙泉驿',label: '龙泉驿'}, 
        {value: '青白江',label: '青白江'}, 
        {value: '新都',label: '新都'},
        {value: '温江',label: '温江'}, 
        {value: '双流',label: '双流'}, 
        {value: '邯郸区',label: '邯郸区'}, 
        {value: '简阳',label: '简阳'}, 
        {value: '都江堰',label: '都江堰'}, 
        {value: '彭州',label: '彭州'}, 
        {value: '邛崃',label: '邛崃'}, 
        {value: '崇州',label: '崇州'}, 
        {value: '金堂',label: '金堂'}, 
        {value: '大邑',label: '大邑'}, 
        {value: '浦江',label: '浦江'}, 
        {value: '新津',label: '新津'}, 
        {value: '高新区',label: '高新区'}, 
        {value: '天府新区',label: '天府新区'}, 
        {value: '高新西区',label: '高新西区'}
      ],
      bayList:[
        // 0 待确认1已发送2已确认
        {value:'全部',label:'全部'},
        {value:'0',label:'待确认'},
        {value:'1',label:'已发送'},
        {value:'2',label:'已确认'},
      ],
      bayValue:'全部',
      tableData:[],
      checkDialogState:false,
      checkDialogTable:[],
      accountArrValue:'',//选择接受账号初始值
      accountArr:[],
      loading:false,
      DIC:DIC,
      compile:false,
      pageSizes:[5, 10, 15, 20],
      pageSizeValue:5,
      total:0,
      pageNo:1,
      goodsDableData:[],
    }
  },
  // created(){

  // },
  mounted () {
    this.info()
  },
  methods: {
    info(state = false){
      if(state){
        this.pageNo = 1
      }
      let data = {
        pageNo:this.pageNo,
        pageSize:this.pageSizeValue,
      }
              // shopStatus:this.bayValue,
      if(this.bayValue !== '全部'){
        data.orderStatus = this.bayValue
      }
      if(this.shopName !== ''){
        data.shopName = this.shopName
      }
      if(this.initShopArea !== '全部'){
        data.shopArea = this.initShopArea
      }
      this.tableData = []
      this.$axios.post('/mtea/stock/order/search', data).then(res => {
        for(let j = 0;j<res.records.length;j++){
          // res.records[j].goodsExtra = JSON.parse(res.records[j].goodsExtra)
          for(let i = 0;i<res.records[j].itemList.length;i++){
            res.records[j].itemList[i].goodsExtra = JSON.parse(res.records[j].itemList[i].goodsExtra)
          }
          res.records[j].getTime = (new Date(res.records[j].createTime).getTime())
        }
        for (var i = 0; i < res.records.length-1; i++) {
          for (var j = 0; j < res.records.length - 1 - i; j++) {
              // 相邻元素两两对比，元素交换，大的元素交换到后面
              if (res.records[j].getTime < res.records[j + 1].getTime) {
                  var temp = res.records[j];
                  res.records[j] = res.records[j+1];
                  res.records[j+1] = temp;
              }
          }
        }
        this.tableData = res.records
        this.total = res.total
      }).catch((err) => {
        console.log(err)
      })
    },
    checkFun(data){
      this.checkDialogState = true
      this.checkDialogTable = data
      this.$axios.post('/mtea/stock/order/info', {shopId:this.checkDialogTable.sysShopId}).then(res => {
        this.accountArr = []
        res.staffList.forEach((e)=>{
          let data = {value:e.staffId,label:e.userName+':'+e.userPhone}
          this.accountArr.push(data)
        })
        if(res.sysStaffId){
          this.accountArrValue = res.sysStaffId
        }else{
          this.accountArrValue = res.staffList[0].staffId
        }
      })
    },
    sizeChange(num){
      this.pageSizeValue = num
      this.info()
    },
    currentChange(num){
      this.pageNo = num
      this.info()
    },
    deleteFun(data){
      this.loading = true
      this.$axios.get('/mtea/stock/order/delete', {params:{sStockOrderId:data.stockOrderId,shopId:data.sysShopId}}).then(res => {
        this.$message({
          message: '删除成功！',
          type: 'success'
        });
        this.info()
      })
    },
    invSubState(){
      this.compile = false
      this.checkDialogState = false
      this.info()
    },
    resendFun(){
      this.$axios.post('/mtea/stock/order/push', {stockOrderId:this.checkDialogTable.stockOrderId,sysStaffId:this.accountArrValue,shopId:this.checkDialogTable.sysShopId}).then(res => {
        this.$message({
          message: '重新发送成功！',
          type: 'success'
        });
      })
    }
  },
}
